import { createContext } from 'react';

import { defaultTooltipVariant } from '../constants.js';
import { TimeseriesChartTooltipConfig } from '../types/timeseries-config.js';

export const TimeseriesTooltipContext =
  createContext<TimeseriesChartTooltipConfig>({
    variant: defaultTooltipVariant,
    seriesDisplayMode: 'single-line',
  });

TimeseriesTooltipContext['displayName'] = 'TimeseriesTooltipContext';
